import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        questionPool: '='
    },
    template: `
        <a class="btn main small" ng-click="vm.manageLanguages(vm.form)">{{ 'general.Manage translations' | translate }}</a>
    `
})
export default class {
    constructor (ModalService, QuestionCategoryResource) {
        this.ModalService = ModalService;
        this.QuestionCategoryResource = QuestionCategoryResource;
    }

    manageLanguages (form) {
        const { questionPool } = this;
        return this.ModalService.open({
            animation: true,
            template: `
                <modals-forms-questionpool-translation
                    update="vm.update()"
                    update-form="vm.form"
                    question-pool="vm.questionPool"
                    cancel="vm.$uibModalInstance.dismiss()"
                    class="wrapper"></modals-forms-questionpool-translation>
                `,
            size: 'xlarge',
            controller ($uibModalInstance, QuestionCategoryResource) {
                this.$uibModalInstance = $uibModalInstance;
                this.questionPool = questionPool;
                this.QuestionCategoryResource = QuestionCategoryResource;
                this.form = form;

                this.update = () => {
                    this.$uibModalInstance.close();
                };
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/settings/pool/translation/index.js